// ** React Imports
import { useEffect, useCallback, useRef, useState, ChangeEvent, ReactNode } from 'react'


// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
/*import MuiDialog from '@mui/material/Dialog'*/
import ListItem from '@mui/material/ListItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

import PerfectScrollbar from 'react-perfect-scrollbar'


// ** Types Imports
import { Option } from 'src/features/autocomplete/types'


// ** API Icon Import with object
import _ from 'lodash'
import FilterDialog from './FilterDialog'
import { Card, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import SprintStore from '../../stores/SprintStore'
import { Filter, FilterCategory, FilterType, OptionWithSelect } from './FilterTypes'
import CustomDatePicker from '../common/CustomDatePicker'
import FilterSelectComponent from './FilterSelectComponent'

interface Props {
    filter: Filter,
    filters: FilterCategory[],
    onFiltersChanged: (updatedDilter: Filter) => void,
    toggleOption: (cat: FilterCategory, opt: Option) => void
}

interface DefaultSuggestionsProps {
    setOpenDialog: (val: boolean) => void
}

interface NoResultProps {
    value: string
    setOpenDialog: (val: boolean) => void
}

interface DefaultSuggestionsType {
    category: string
    suggestions: {
        link: string
        icon: ReactNode
        suggestion: string
    }[]
}

// ** Styled Autocomplete component

const AutocompleteComponent = ({ filters, toggleOption, filter, onFiltersChanged }: Props) => {
    const [searchValue, setSearchValue] = useState('');
    const [optionsFiltered, setOptionsFiltered] = useState([] as FilterCategory[])
    const [activeItemIndex, setActiveItemIndex] = useState(0);
    const [activeItemIndex2, setActiveItemIndex2] = useState(0);
    const [activeOptionValue, setActiveOptionValue] = useState('')
    /*const leadFilters = SprintStore.useState(s => s.leadFilters);*/
    const theme = useTheme()


    useEffect(() => {
        let clonedOptions = _.cloneDeep(filters);

        const upperCasedValue = searchValue.toUpperCase();

        clonedOptions = clonedOptions.filter(s => upperCasedValue === '' || s.category.toUpperCase().includes(upperCasedValue)
            || s.options.some(o => o.name.toUpperCase().includes(upperCasedValue)));

        clonedOptions.forEach(cat => {
            if (cat.category.toUpperCase().startsWith(upperCasedValue)) {
                cat.filteredOptions = _.cloneDeep(cat.options);
                return;
            }
            cat.filteredOptions = cat.options.filter(s => upperCasedValue === '' || s.name.toUpperCase().includes(upperCasedValue));
        })


        const displayItems = [] as FilterCategory[];

        clonedOptions.forEach(cat => {
            const hasMore = cat.filteredOptions.length > 4;

            displayItems.push({
                ...cat,
                filteredOptions: cat.filteredOptions.slice(0, 4),
                hasMore: hasMore
            })
        })

        setOptionsFiltered(displayItems);
    }, [searchValue, filters])

    useEffect(() => {
        setActiveOptionValue(optionsFiltered[0]?.filteredOptions[0]?.value ?? '');
    }, [optionsFiltered])

    // Handle ESC & shortcut keys keydown events
    const handleKeydown = useCallback(
        (event: KeyboardEvent) => {
            // ** Shortcut keys to open searchbox (Ctrl + /)
            // down 40
            // up 38
            // right 39
            // left 37


            if (event.keyCode === 38) setActiveItemIndex(value => value - 1);
            if (event.keyCode === 40) setActiveItemIndex(value => value + 1);

            if (event.keyCode === 37) setActiveItemIndex2(value => value - 1);
            if (event.keyCode === 39) setActiveItemIndex2(value => value + 1);

            var isNext = false;

            for (var catCount = 0; catCount < optionsFiltered.length; catCount++) {
                const cat = optionsFiltered[catCount];

                for (var optCount = 0; optCount < optionsFiltered.length; optCount++) {
                    const opt = cat.options[optCount];

                    if (isNext) {
                        setActiveOptionValue(opt.value);
                        return;
                    }

                    if (opt.value === activeOptionValue) isNext = true;
                }
            }

            console.log(event.keyCode)
            console.log(activeItemIndex)
        },
        [optionsFiltered, activeOptionValue]
    )

    // Handle shortcut keys keyup events
    const handleKeyUp = useCallback(
        (event: KeyboardEvent) => {
        },
        []
    )

    useEffect(() => {
        document.addEventListener('keydown', handleKeydown)
        document.addEventListener('keyup', handleKeyUp)

        return () => {
            document.removeEventListener('keydown', handleKeydown)
            document.removeEventListener('keyup', handleKeyUp)
        }
    }, [handleKeyUp, handleKeydown])

    const showMore = (cat: FilterCategory) => {

    }



    const onActivityDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.activityDate = value;

        onFiltersChanged(updatedFilter);
    }

    const onStartDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.startDate = value;
        onFiltersChanged(updatedFilter);
    }

    const onEndDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.endDate = value;
        onFiltersChanged(updatedFilter);
    }

    return <Card sx={{ padding: 0, paddingTop: 0, minHeight: '100%', maxHeight: '100%', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
        <TextField name={`lead-filter`} autoFocus value={searchValue} onChange={(e) => setSearchValue(e.target.value)} size='small' fullWidth sx={{ mb: 4 }} placeholder="Search Filters" />

        <PerfectScrollbar options={{ wheelPropagation: false }} id='filters-card' className='ps-show-always'>
            <Box sx={{ minHeight: '0', height: '100%', display:'flex', flexGrow: 2 }}>
                <Grid container spacing={2} sx={{ ml: 0 }}>
                    {optionsFiltered.map((cat, index) => (
                        <FilterSelectComponent cat={cat} activeOptionValue={activeOptionValue} searchValue={searchValue} toggleOption={toggleOption} filter={filter} />
                    ))}
                </Grid>
            </Box>
        </PerfectScrollbar>

        <Grid container rowGap={2} spacing={2} sx={{ pt: 10 }}>

            {filter.filterType == FilterType.User && <Grid item xs={4}>
                <FormControl size="small" fullWidth>
                    <InputLabel>Next Activity Date</InputLabel>
                    <Select value={filter.activityDate} onChange={(e) => onActivityDateChange(e.target.value)} label="Next Activity Date">
                        <MenuItem value='today'>Today</MenuItem>
                        <MenuItem value='overduegt10'>Overdue &gt; 10 Days</MenuItem>
                        <MenuItem value='overduelt10'>Overdue &lt; 10 Days</MenuItem>
                        <MenuItem value='tomorrow'>Tomorrow</MenuItem>
                        <MenuItem value='thisweek'>This Week</MenuItem>
                        <MenuItem value='thismonth'>This Month</MenuItem>
                        <MenuItem value='thisyear'>This Year</MenuItem>
                        <MenuItem value='nextweek'>Next Week</MenuItem>
                        <MenuItem value='nextmonth'>Next Month</MenuItem>
                        <MenuItem value='any'>Any</MenuItem>
                        <MenuItem value='selectperiod'>Select Period</MenuItem>
                    </Select>
                </FormControl>
            </Grid>}
            <Grid item xs={4}>
                {filter.activityDate == 'selectperiod' && <CustomDatePicker value={filter.startDate ?? ''} onChange={onStartDateChange} label="Start Date" />}
            </Grid>
            <Grid item xs={4}>
                {filter.activityDate == 'selectperiod' && <CustomDatePicker value={filter.endDate ?? ''} onChange={onEndDateChange} label="End Date" />}
            </Grid>
        </Grid>
    </Card>
}

export { AutocompleteComponent }
export default AutocompleteComponent